var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"conversation"},[_c('Chatbot',{key:"chatbot",staticClass:"chatbot",attrs:{"flow":_vm.conversationFlow},on:{"finished":function () { return null; }}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }